import React from 'react';
import SortingDesktop from "./SortingDesktop";

export default function SortingWrapper(props) {

    const filter = props.filter;

    return (
       <>{
           props.isMobile
           ? <SortingDesktop filter={filter} classes={props.classes} isMobile={props.isMobile} user={props.user}/>
           : <SortingDesktop filter={filter} classes={props.classes} isMobile={props.isMobile} user={props.user}/>
        }
       </>
    )
}